import React, { useState, useRef } from "react";
import {
  TestimonialsBase,
  Title,
  TestimonialWrapper,
  Content,
  AllTestimonials,
  SliderClass,
  Slide,
  SliderArrow,
  SliderNav,
} from "./testimonials.styled";
import { TestimonialsSliceFragment } from "../../types/graphql";
import Testimonial from "../../components/testimonial/testimonial";
import { Slice } from "@prismicio/types";
import { SharedSliceType } from "../shared-slice/shared-slice";
import { SliceComponentProps } from "@prismicio/react";
import { IPageContext } from "../../types/types";
import * as FA from "../../styles/fontawesome";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import theme from "../../styles/theme";

export type ITestimonialsProps = Slice<
  SharedSliceType.testimonials,
  TestimonialsSliceFragment["primary"],
  TestimonialsSliceFragment["items"][number]
> & { type: SharedSliceType };

const Testimonials = ({
  slice,
  context,
}: SliceComponentProps<ITestimonialsProps, IPageContext>) => {
  const title = slice.primary?.title;
  const testimonials = slice.items;

  if (!testimonials) return <></>;

  const sliderRef = useRef<Slider>(null);
  const [sliderInitialized, setSliderInitialized] = useState(false);

  return (
    <TestimonialsBase className="slice-section">
      <Content className="container">
        {title && (
          <header>
            <Title>{title}</Title>
          </header>
        )}

        <AllTestimonials>
          <Slider
            className={SliderClass}
            dots={false}
            speed={500}
            slidesToScroll={2}
            infinite={false}
            arrows={false}
            ref={sliderRef}
            centerMode={false}
            autoplay={false}
            variableWidth={true}
            initialSlide={0}
            onInit={() => setSliderInitialized(true)}
            autoplaySpeed={2500}
            slidesToShow={2}
            responsive={[
              {
                breakpoint: theme.breakpoints[3],
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  autoplay: false,
                  centerMode: false,
                  infinite: false,
                  variableWidth: false,
                },
              },
            ]}
          >
            {sliderInitialized &&
              testimonials.map((testimonial, index) => {
                const testimonialProps = {
                  slice_type: "testimonial",
                  slice_label: "",
                  primary: testimonial,
                  items: [],
                  type: SharedSliceType.testimonial,
                };
                return (
                  <Slide key={index}>
                    <TestimonialWrapper>
                      <Testimonial
                        slice={testimonialProps}
                        context={context}
                        index={index}
                        slices={[]}
                      />
                    </TestimonialWrapper>
                  </Slide>
                );
              })}
          </Slider>
          <SliderNav>
            <SliderArrow onClick={() => sliderRef.current?.slickPrev()}>
              <i css={FA.AngleLeftRegular} />
            </SliderArrow>
            <SliderArrow onClick={() => sliderRef.current?.slickNext()}>
              <i css={FA.AngleRightRegular} />
            </SliderArrow>
          </SliderNav>
        </AllTestimonials>
      </Content>
    </TestimonialsBase>
  );
};

export default Testimonials;
